
define(
	'Code25.CaterpartsGlobal.ProductLists'
	, [

	]
	, function (

	) {
		'use strict';
		return {
			mount: function mount(container) {

				
					var ProductListDisplayFullView = require("ProductList.DisplayFull.View");
					if (ProductListDisplayFullView) {
						if (ProductListDisplayFullView.FacetsItemCellView) {
							ProductListDisplayFullView = ProductListDisplayFullView.FacetsItemCellView;
						}
						_.extend(ProductListDisplayFullView.prototype, {

							getContext: _.wrap(ProductListDisplayFullView.prototype.getContext, function (getContext) {

								var res = getContext.apply(this, _.rest(arguments));
								res.model=this.model;
								return res;

							})
						});
					}

			}

		}

	});
